<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Data Share</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<div class="switches" white-background>
	    		<v-switch label="Allow Data Share" v-model="status" :disabled="toggling" @change="fn_toggleDataShare" nomargin></v-switch>
	    	</div>

	    </div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				status:false,
				toggling:false
			}
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_toggleDataShare: function(value){
				if(!navigator.onLine){
					this.status = !value;
					this.showToast("Internet not available");
					return;
				}

				this.toggling = true;

				let filterObj = {};
				filterObj.businessId = this.$root.CurrentBusiness.BusinessID;
				filterObj.IsTemporary = this.$root.CurrentBusiness.temporaryBusiness ? true : false;

				let toggleValue = value ? true : false;
				let self = this;
	          	this.getFilterData("WatchForegroundService", JSON.stringify(toggleValue), filterObj,
	              	{
	                  	onSuccess: function(response){
	                    	console.log(response);
	                    	// let status = JSON.parse(response);
	                    	if(value){
	                    		self.showToast("Data sharing enabled");
	                    	}
	                    	else{
	                    		self.showToast("Data sharing disabled");
	                    	}

	                    	self.toggling = false;
	                  	}, 
	                  	onError: function(error){
	                      	console.log(error);

	                      	if(value){
	                    		self.showToast("Unable to enable data share.");
	                    	}
	                    	else{
	                    		self.showToast("Unable to disable data share.");
	                    	}

	                      	self.status = !self.status;
	                      	self.toggling = false;
	                  	}
	              	}
	          	);
			},

			fn_appDataShareStatus: function(){
				let self = this;
	          	this.getData("WatcherRunning", null, 
	              	{
	                  	onSuccess: function(response){
	                    	console.log(response);
	                    	self.status = JSON.parse(response);
	                    	// self.security.appLock = status == 1 ? true : false;
	                  	}, 
	                  	onError: function(error){
	                      	console.log(error);
	                  	}
	              	}
	          	);
			}
		},


	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  		this.fn_appDataShareStatus();
	  	}
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/datashare/toggle_data_share.vue